import React, {Component} from 'react';
import Styles from './style.css';
import cx from 'classnames';
import {langRegister} from "../../services/langRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";

class BoosterHomeCompare extends Component {

    constructor(props) {
        super(props);
        this.state = {
            items: []
        };
    };

    componentWillMount() {
        this._updateItems();
    }

    _updateItems() {
        let items = [
            {
                title: this._renderText("item_1"),
                subtitle: this._renderText("item_16"),
                adbop: {exist: true, value: this._renderText("item_20")},
                adwords: {exist: true, value: this._renderText("item_23")}
            },
            {
                title: this._renderText("item_3"),
                adbop: {exist: true, value: "X"},
                adwords: {exist: true, value: "X"}
            },
            {
                title: this._renderText("item_4"),
                adbop: {exist: true, value: "X"},
                adwords: {exist: true, value: "X"}
            },
            {
                title: this._renderText("item_24"),
                adbop: {exist: true, value: "X"},
                adwords: {exist: true, value: "X"}
            },
            {
                title: this._renderText("item_5"),
                adbop: {exist: true, value: "X"},
                adwords: {exist: true, value: "X"}
            },
            {
                title: this._renderText("item_25"),
                adbop: {exist: true, value: "X"},
                adwords: {exist: true, value: "X"}
            },
            {
                title: this._renderText("item_6"),
                adbop: {exist: true, value: "X"},
                adwords: {exist: true, value: "X"}
            },
            {
                title: this._renderText("item_7"),
                adbop: {exist: true, value: "X"},
                adwords: {exist: true, value: "X"}
            },
            {
                title: this._renderText("item_8"),
                adbop: {exist: true, value: "X"},
                adwords: {exist: true, value: "X"}
            },
            {
                title: this._renderText("item_9"),
                adbop: {exist: true, value: "X"},
                adwords: {exist: true, value: "X"}
            },
            {
                title: this._renderText("item_10"),
                adbop: {exist: true, value: "X"},
                adwords: {exist: true, value: "X"}
            }
        ];
        this.setState({items: items});
    }

    boost(){
        window.scrollTo(0, 0);
    }

    _renderText(item) {
        return langRegister.get("home-sections-eight", item);
    }

    render() {
        return (
            <div className={Styles.section}>
                <div className={Styles.container}>
                    <div className={Styles.table}>
                        <div className={cx(Styles.tableItem)}>
                            <div className={Styles.tableSectionOne}/>
                            <div className={cx(Styles.tableSectionTwo, Styles.tableItemTop)}>
                                <div className={Styles.tableTitle}>
                                    {this._renderText("item_17")}
                                </div>
                            </div>
                            <div className={cx(Styles.tableSectionThree, Styles.tableItemTop)}>
                                <div className={Styles.tableTitle}>
                                    {this._renderText("item_18")}
                                </div>
                            </div>
                        </div>
                        {
                            this.state.items.map((item, key) => {
                                return (
                                    <div className={Styles.tableItem}>
                                        <div className={Styles.tableSectionOne}>
                                            <div className={Styles.tableSectionOneTitle}>
                                                {item.title}
                                                {
                                                    item.subtitle &&
                                                        <span className={Styles.tableSectionOneSubtitle}>{" "}{item.subtitle}</span>
                                                }
                                            </div>
                                        </div>
                                        <div className={
                                            cx(Styles.tableSectionTwo,
                                                {
                                                    [Styles.tableSectionTwoActive]: item.adbop.exist,
                                                    [Styles.tableSectionTwoActiveFirst]: key === 0,
                                                    [Styles.tableSectionTwoActiveLast]: key === this.state.items.length - 1,
                                                })
                                        }>
                                            <div className={Styles.tableSectionTitle}>
                                                {
                                                    item.adbop.value === 'X' && salesChannelRegister.get("name") === "propertybooster" &&
                                                    <img className={Styles.tableSectionTitleIcon} src={require("../../assets/images/AB_checkmark_reseller.png")}/>
                                                }
                                                {
                                                    item.adbop.value === 'X' && salesChannelRegister.get("name") === "boostabostad" &&
                                                    <img className={Styles.tableSectionTitleIcon} src={require("../../assets/images/AB_checkmark_boostabostad.png")}/>
                                                }
                                                {
                                                    item.adbop.value !== 'X' &&
                                                    <span>{item.adbop.value}</span>
                                                }
                                            </div>
                                        </div>
                                        <div className={
                                            cx(Styles.tableSectionThree,
                                                {
                                                    [Styles.tableSectionThreeActive]: item.adwords.exist,
                                                })
                                        }>
                                            <div className={Styles.tableSectionTitleSecond}>
                                                {item.adwords.value}
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div onClick={() => this.boost()} className={Styles.button}>
                        {this._renderText("item_19")}
                    </div>
                </div>
            </div>
        );
    }
}

export default BoosterHomeCompare;


// WEBPACK FOOTER //
// ./src/components/booster-home-compare/component.js